module.exports = __webpack_public_path__ + "images/2a07e00.png";